module.exports = __webpack_public_path__ + "static/media/Teresina-oval.bd2a020c.jpg";